export default "__VITE_ASSET__DKEYKB5I__"